import React from 'react'
import { DynamicForm, FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';
import Toast from 'react-hot-toast';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import './toolbar.css'
import ACCESS from '../../../ACCESS';

class UnidadTransporte extends FormComponent {

  state = {
    FormData: new Form([
      Form.Section('Datos Chofer'),
      Form.Field('text', 'unidad', 'Unidad', '', [Validators.required], 6),
      Form.Field('select', 'id_transportista', 'Transportista', '', [Validators.required], 6),
      Form.Field('text', 'ut_chofer', 'Chofer Nombre Completo', '', [Validators.required], 12),
      Form.Field('text', 'chofer_rfc', 'RFC', '', [Validators.required, Validators.rfc_fisica], 6),
      Form.Field('text', 'chofer_numero_licencia', 'Numero de Licencia', '', [Validators.required], 6),
      Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 6),
      Form.Field('text', 'ut_telefono', 'Teléfono', '', [Validators.required], 6),
      Form.Field('text', 'ut_cel_modelo', 'Modelo de celular', '', [Validators.required], 6),
      Form.Field('text', 'ut_imei', 'IMEI', '', [Validators.required], 6),
      Form.Field('text', 'ut_cel_proveedor', 'Proveedor de celular', '', [Validators.required], 6),
      Form.Section('Domicilio Chofer'),
      Form.Field('text', 'chofer_calle', 'Calle', '', [Validators.required], 6),
      Form.Field('text', 'chofer_numero', 'Numero Exterior', '', [Validators.required], 6),
      Form.Field('autocomplete-async-cp', 'codigo_postal', '*C.P.', '', [Validators.required], 6, [], [], [], false, false, '', 'search/codigo-postal'),
      Form.Field('select', 'chofer_id_colonia', 'Colonia', '', [Validators.required], 6),
      Form.Field('text', 'estado', 'Estado', '', [], 6, [], [], [], false, true),
      Form.Field('text', 'ciudad', 'Ciudad', '', [], 6, [], [], [], false, true),
    ], [], 'Crear Unidad de Transporte'),
    loading: true,
    loadingData: true,
    loadingError: '',
    id_unidad_transporte: null,
    modal: null,
    saving_pass: false,
    temporal_pass: null,
    activo: true,
    saving_active: false
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.loadData();
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    let id = this.props.match.params.id;
    this.FillForm().then((f) => {
      if (id) {
        this.LoadPreds(id).then(l => {
          this.setState({ loadingData: false, loading: false });
        }).catch(() => {
          this.setState({ loadingError: 'Error al cargar (1)', loadingData: false });
        })
      } else {
        this.setState({ loading: false, loadingData: false });
      }
    }).catch(() => {
      this.setState({ loadingError: 'Error al cargar (2)', loadingData: false })
    });
  }

  FillForm = async () => {
    let id_unidad_transporte = this.props.match.params.id;
    let params = { id_unidad_transporte };
    let newForm = { ...this.state.FormData };
    try {
      const Res = await Http.get(`unidad-transporte/form?${objectAsParams(params)}`);
      if (!Res || Res.error) {
        this.setState({ loadingError: 'Error al cargar el Formulario (1)' })
      }
      newForm.Fields = newForm.Fields.map(fi => {
        if (fi.Name === 'chofer_id_colonia' && Res.data.colonias) {
          fi.Options = Res.data.colonias;
        } else if (fi.Name === 'id_transportista' && Res.data.transportistas) {
          fi.Options = Res.data.transportistas;
        } else if (fi.Name === 'id_sucursal' && Res.data.sucursales) {
          fi.Options = Res.data.sucursales;
        }
        return fi;
      })
      this.setState({ FormData: newForm });
    } catch (error) {
      this.setState({ loadingError: 'Error al cargar el Formulario (2)' })
    }
  }

  LoadPreds = async (predId = null) => {
    let { FormData } = this.state;
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`unidad-transporte/one/${id}`);
    if (!Res.error) {
      FormData.Title = `Editar Unidad de Transporte #${id}`
      FormData.Fields = FormData.Fields.map(fi => {
        if (fi.Name === 'codigo_postal') {
          fi.Options = [{ Label: Res.data.codigo_postal, Value: Res.data.codigo_postal }]
        }
        return fi;
      })
      if (Res.data && Res.data.chofer_rfc && !['', null, undefined].includes(Res.data.chofer_rfc)) {
        let validatorrfc = Validators.rfc_fisica;
        FormData.Fields = FormData.Fields.map(field => {
          if (field.Name === 'chofer_rfc') {
            field.Validators = [validatorrfc]
          }
          return field
        })
      }
      this.setState({
        id_unidad_transporte: Res.data.id,
        activo: Res.data.activo !== false && Res.data.activo !== 0,
        FormData: Form.Patch(FormData, {
          unidad: Res.data.unidad,
          id_transportista: Res.data.id_transportista,
          ut_chofer: Res.data.ut_chofer,
          chofer_rfc: Res.data.chofer_rfc,
          chofer_numero_licencia: Res.data.chofer_numero_licencia,
          id_sucursal: Res.data.id_sucursal,
          ut_telefono: Res.data.ut_telefono,
          ut_cel_modelo: Res.data.ut_cel_modelo,
          ut_imei: Res.data.ut_imei,
          ut_cel_proveedor: Res.data.ut_cel_proveedor,
          chofer_calle: Res.data.chofer_calle,
          chofer_numero: Res.data.chofer_numero,
          codigo_postal: Res.data.codigo_postal,
          chofer_id_colonia: Res.data.chofer_id_colonia,
          estado: Res.data.estado,
          ciudad: Res.data.ciudad,
        }),
      });
      return Res.data;
    } else {
      this.setState({ loadingError: 'Error al cargar informacion(2)', loadingData: false });
    }
    return null;
  }

  onChoferCpChange = (field, newForm) => {
    let choferCP = field.Options.find(o => o.Value === field.Value) || {};
    let chofer_data = {
      estado: choferCP.estado || '',
      ciudad: choferCP.ciudad || '',
      chofer_id_colonia: null,
    }
    newForm.Fields = newForm.Fields.map(f => {
      if (f.Name === 'chofer_id_colonia') {
        f.Options = choferCP.colonias ? choferCP.colonias : [];
      }
      return f;
    });
    newForm = Form.Patch(newForm, chofer_data);
    return newForm;
  }

  formChange = (form, field, type) => {
    let newForm = { ...form };
    if (field.Name === 'codigo_postal' && type !== 'options') {
      newForm = this.onChoferCpChange(field, newForm)
    }

    this.setState({ FormData: newForm });
  }

  onSubmit = async (event) => {
    event.preventDefault();
    const { loading, id_unidad_transporte } = this.state;
    if (loading) return;
    this.setState({ loading: true });
    let vals = {};
    const { FormData } = this.state;
    let valid = Form.ValidateForm(FormData);
    if (valid !== true) {
      this.setState({ loading: false });
      return Toast.error(`Error en el campo '${valid.name}'`)
    }
    vals = Form.FieldsValues(FormData);

    try {
      const url = id_unidad_transporte ? `unidad-transporte/edit` : `unidad-transporte/save`;
      vals.id_unidad_transporte = id_unidad_transporte;
      const Res = await Http.post(url, vals);
      if (!Res.error) {
        Toast.success(id_unidad_transporte ? `Se actualizo la unidad de transporte correctamente` : 'Se creo la unidad de transporte correctamente')
        this.setState({
          loading: false,
          sbOpen: true,
          FormData: Form.Reset(this.state.FormData),
          id_unidad_transporte: null,
        });
        return this.props.history.push(`/Catalogo/UnidadesTransporte`);
      } else {
        Toast.error(Res.errMsg)
        this.setState({ loading: false });
      }
    } catch (error) {
      Toast.error(`Error inesperado al guardar la unidad de transporte`)
    }
  }

  onSubmitNewPass = async (event) => {
    event.preventDefault();
    const { saving_pass, id_unidad_transporte } = this.state;
    if (saving_pass) return;
    this.setState({ saving_pass: true });

    try {
      const Res = await Http.post('unidad-transporte/temporal-password', { id_unidad_transporte });
      if (!Res.error) {
        this.setState({
          saving_pass: false,
          temporal_pass: Res.data.password
        });
      } else {
        Toast.error(Res.errMsg)
        this.setState({ saving_pass: false });
      }
    } catch (error) {
      this.setState({ saving_pass: false });
      Toast.error(`Error inesperado al generar contraseña`)
    }
  }

  onToggleActive = async () => {
    const { id_unidad_transporte, saving_active } = this.state;
    if (saving_active) return;
    this.setState({ saving_active: true });

    try {
      const Res = await Http.post('unidad-transporte/toggle-active', { id_unidad_transporte });
      if (!Res.error) {
        Toast.success(Res.data.activo ? 'Se habilitó al chofer correctamente' : 'Se deshabilitó al chofer correctamente');
        this.setState({
          saving_active: false,
          modal: null,
          activo: Res.data.activo
        });
      } else {
        Toast.error(Res.errMsg);
        this.setState({ saving_active: false });
      }
    } catch (error) {
      this.setState({ saving_active: false });
      Toast.error('Error inesperado al cambiar el estado del chofer');
    }
  }

  render() {
    const { FormData, loadingData, loadingError, loading, id_unidad_transporte, modal, saving_pass, temporal_pass, activo, saving_active } = this.state;
    const { hasAccess } = this.context;

    if (loadingData) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <CircularProgress size={"50px"} color="primary" />
        <div><h3>Cargando...</h3></div>
      </div>
    }

    if (loadingError) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <h3>{loadingError}</h3>
      </div>
    }

    return (
      <div>
        {!!id_unidad_transporte && (
          <div style={{ padding: 5, paddingTop: 10 }} >
            <div className="toolbar">
              {hasAccess(ACCESS.CATALOGO_UNIDADES_DE_TRANSPORTE.GENERAR_CONTRASENA) && (
                <div className="toolbar-item toolbar-item-password" onClick={() => { this.setState({ modal: "password" }) }} >Generar Password</div>
              )}
              {hasAccess(ACCESS.CATALOGO_UNIDADES_DE_TRANSPORTE.EDITAR_CATALOGO) && (
                <div className={`toolbar-item toolbar-item-toggle ${activo ? 'active' : 'inactive'}`} onClick={() => { this.setState({ modal: "toggle_active" }) }} >
                  {activo ? "Deshabilitar Chofer" : "Habilitar Chofer"}
                </div>
              )}
            </div>
          </div>
        )}
        <DynamicForm
          form={FormData}
          disabled={false}
          formChange={this.formChange}
        />
        <div style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'flex-end',
          marginTop: 10
        }} >
          <Button
            style={{ marginRight: 5 }}
            variant='contained'
            disabled={loading}
            onClick={this.onSubmit}
            color='primary'>
            {loading && <CircularProgress color="secondary" size={20} />}
            {`Guardar Unidad ${id_unidad_transporte ? `#${id_unidad_transporte}` : ''} `}
          </Button>
        </div>

        <Dialog
          open={modal === 'password'}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Generar nueva contraseña</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {temporal_pass ? <div>
                <h2 style={{ textAlign: 'center', fontFamily: "Consolas" }} >Contraseña Temporal: <br />{temporal_pass}</h2>
              </div>
                : <div>
                  Se generará una contraseña para la aplicación Exxprezo Delivery.<br />
                  En caso de existir una contraseña previa, será eliminada y reemplazada.<br />
                  La nueva contraseña será de un solo uso y la aplicación solicitará al usuario crear una contraseña.
                </div>}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.setState({ modal: null, temporal_pass: null }) }} color="default" disabled={saving_pass}>
              {!temporal_pass ? "Cancelar" : "Cerrar"}
            </Button>
            {!temporal_pass && (
              <Button onClick={this.onSubmitNewPass} color="primary" variant="contained" disabled={saving_pass} >
                {saving_pass && <CircularProgress size={"20px"} color="secondary" />}
                Aceptar
              </Button>
            )}
          </DialogActions>
        </Dialog>

        <Dialog
          open={modal === 'toggle_active'}
          aria-labelledby="alert-dialog-title-active"
          aria-describedby="alert-dialog-description-active"
        >
          <DialogTitle id="alert-dialog-title-active">
            {activo ? "Deshabilitar Chofer" : "Habilitar Chofer"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description-active">
              ¿Está seguro de que desea {activo ? "deshabilitar" : "habilitar"} a este chofer?
              {activo && (
                <span>
                  <br /><br />
                  <strong>Importante:</strong> Una vez deshabilitado, el chofer perderá inmediatamente el acceso a la aplicación Exxprezo Delivery.
                </span>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { this.setState({ modal: null }) }} color="default" disabled={saving_active}>
              Cancelar
            </Button>
            <Button onClick={this.onToggleActive} color="primary" variant="contained" disabled={saving_active} >
              {saving_active && <CircularProgress size={"20px"} color="secondary" />}
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withRouter(UnidadTransporte)
